// شريط تنقّل موحّد داخل لوحة الأدمن (اقتراحات / عجلات / مواسم).
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import { ArrowRight, LogOut, MessagesSquare, Layers, CalendarClock, Shield, RefreshCcw } from "lucide-react";

const NAV_ITEMS = [
  { to: "/admin/suggestions", label: "الاقتراحات", icon: MessagesSquare, testId: "nav-suggestions" },
  { to: "/admin/events", label: "العجلات", icon: Layers, testId: "nav-events" },
  { to: "/admin/seasons", label: "المواسم", icon: CalendarClock, testId: "nav-seasons" },
  { to: "/admin/sync", label: "المزامنة التلقائية", icon: RefreshCcw, testId: "nav-sync" },
];

const AdminHeader = ({ title = "لوحة الإدارة" }) => {
  const { user, logout } = useAdminAuth();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-lg bg-[#0A1128]/85 border-b border-white/5">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3 flex-wrap">
        <Link
          to="/"
          data-testid="admin-back-home"
          className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 text-white text-xs font-semibold transition-colors"
        >
          <ArrowRight className="w-4 h-4" />
          <span className="hidden sm:inline">الموقع</span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2 order-3 sm:order-none w-full sm:w-auto overflow-x-auto">
          {NAV_ITEMS.map((it) => {
            const active = location.pathname.startsWith(it.to);
            const Icon = it.icon;
            return (
              <Link
                key={it.to}
                to={it.to}
                data-testid={it.testId}
                className={`inline-flex items-center gap-1.5 px-3 h-9 rounded-lg text-[11px] sm:text-xs font-bold border transition-colors whitespace-nowrap ${
                  active
                    ? "bg-[#C9A96A]/15 border-[#C9A96A]/40 text-[#E5CB94]"
                    : "bg-white/[0.02] border-white/10 text-slate-300 hover:border-[#C9A96A]/25"
                }`}
              >
                <Icon className="w-3.5 h-3.5" />
                {it.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2 text-white">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-b from-[#D4B278] to-[#B08A4A] text-[#0A1128] flex items-center justify-center">
            <Shield className="w-4 h-4" />
          </div>
          <div className="text-xs sm:text-sm">
            <div className="font-black">{title}</div>
            <div className="text-white/40 text-[10px]">{user?.email}</div>
          </div>
          <button
            type="button"
            data-testid="admin-logout"
            onClick={() => {
              logout();
              navigate("/admin", { replace: true });
            }}
            className="inline-flex items-center gap-1.5 h-9 px-3 rounded-xl bg-white/[0.04] hover:bg-red-500/15 border border-white/10 hover:border-red-500/40 text-white/70 hover:text-red-200 text-xs font-bold transition"
          >
            <LogOut className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">خروج</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
